import {httpPostWithoutIntercept} from './http.service';

export enum AuthService {
    ZOOM = 'zoom',
    AAIEDU = 'aaiedu',
    EMEDIKUS = 'emedikus',
}

export const handleExternalAuthCallback = async (code: string, authService: AuthService): Promise<void> => {
    await httpPostWithoutIntercept(`admin/auth/codeToken/${authService}`, {code});
};
